import SessionEventProto from "../session-event-proto"
import {EVENT_BUS_SESSION_AI_AGENTS_CHANGED} from "./@const"

export default class SessionEvent_AiAgentDelete extends SessionEventProto {

    private aiAgent: { id: ID }

    constructor(sessionEvent: any) {
        super(sessionEvent)
        this.aiAgent = sessionEvent.aiAgent
    }

    process() {
        const id = this.aiAgent?.id
        if (!id) return

        const agent = gd.session.aiAgents.get(id)
        if (!agent) return

        agent.isDeleted = true
        gd.bus.triggerEvent(EVENT_BUS_SESSION_AI_AGENTS_CHANGED)
    }
}
